export const links = {
  RGCams: "http://go.goaserv.com/redirect.go?pid=390&spaceid=1244532",
  // eslint-disable-next-line
  RGCamsDesktop: "https://prtord.com/?siteId=wl3&cobrandId=257522&superCategoryName=&categoryName=&pageName=home&performerName=&prm[psid]=RedGIFs&prm[pstool]=205_1&prm[psprogram]=cbrnd&prm[campaign_id]=&subAffId={SUBAFFID}&prm[utm_source]=menu&filters=",
};
